import { getPlanTooltip } from "~/constants/plan";
import { useResolvedHas } from "~/feature/subscription/hooks/useResolvedHas";

export const usePlanGiftIcon = () => {
  const { planByPublicMetadata } = useResolvedHas();

  const tooltip = planByPublicMetadata
    ? getPlanTooltip(planByPublicMetadata.name)
    : null;

  return { tooltip };
};
